
class AjaxCart extends HTMLElement {
    constructor() {
      super();

      this.cartForm = this.querySelector('form[data-cart-form]');
      this.cartDrawer = document.querySelector('#component-cart-drawer');

      this.updateEvents();

      // Store handler reference for cleanup
      this._handleKeydown = (e) => {
        if (e.key === 'Enter' || e.keyCode === 13) {
            e.preventDefault();
        }
      };

      // Prevent form submission on Enter key press
      if (this.cartForm) {
        this.cartForm.addEventListener('keydown', this._handleKeydown);
      }

      this.removeDraftVariant();

      // this.cartForm.addEventListener('keydown', (e)=>{
      //   if (e.key === 'Enter' || e.keyCode === 13) {
      //       e.preventDefault();
      //   }
      // });

      // Store unsubscribe function for cleanup
      this._handleCartUpdate = (data) => {
        const { action, item, section, elementToFocus } = data.data;
        this._updateCart(section, elementToFocus);
      };
      // this.unsubscribeCartUpdate = eventBus.subscribe(PUB_SUB_EVENTS.cartUpdate, this._handleCartUpdate);

      // if (navigator.platform === 'iPhone') document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
      const userAgent = window.navigator.userAgent || '';
      if (/\biPhone\b/i.test(userAgent)) {
        document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
      }
    }

    /**
     * Observe attribute of component
     * 
     * @returns {array} Attributes to Observe
     */
    static get observedAttributes() {
      return ['updating'];
    }

    removeDraftVariant(){
      this.cartForm.querySelectorAll('[data-item-remove]').forEach(button => {
        if(button.getAttribute('data-remove') == true || button.getAttribute('data-remove') == "true"){
          this.updateItemQty(button.dataset.index, 0, true);
        }
      });
    }

    /**
     * bind Other inside element events to DOM
     */
    updateEvents(){
      this.cartForm.querySelectorAll('[data-item-remove]').forEach(button => button.addEventListener('click', this.removeItem.bind(this)));

      this.cartForm.querySelectorAll('[data-item-remove]').forEach(button =>{
        button.addEventListener('keyup', (e) => {
          if (e.key === 'Enter' || e.keyCode === 13) {
          this.removeItem(e)
          }
        })
      });

     

      this.cartForm.querySelectorAll('[data-qty-input]').forEach(button => button.addEventListener('change', (evt)=>{
        this.onQtyChange(evt);
      }));

      // Kit Bundle events (behind feature flag)
      if (window.globalSpace?.settings?.enable_kit_bundles) {
        this.cartForm.querySelectorAll('[data-kit-remove]').forEach(btn => {
          btn.addEventListener('click', (e) => this._removeKit(e));
          btn.addEventListener('keyup', (e) => { if (e.key === 'Enter') this._removeKit(e); });
        });

        this.cartForm.querySelectorAll('[data-kit-qty-btn]').forEach(btn => {
          btn.addEventListener('click', (e) => this._onKitQtyBtn(e));
          btn.addEventListener('keyup', (e) => { if (e.key === 'Enter') this._onKitQtyBtn(e); });
        });

        this.cartForm.querySelectorAll('[data-kit-qty-input]').forEach(input => {
          input.addEventListener('change', (e) => this._updateKitQty(e));
        });
      }

      window?.Shopify?.PaymentButton?.init();
    }
  
    /**
     * Open Cart drawer and add focus to drawer container
     */
    initCartDrawer(elementTofocus) {
      if(this.cartDrawer){
        this.cartDrawer.openDrawer(elementTofocus);
      } else {
        window.location.href = window.routes.cart_fetch_url || '/cart';
      }
    }
  
     /**
     * Fetch latest cart data 
     */
     getCartData(){
      const cartRoute = `${window.location.pathname}?sections=${this.dataset.sectionId}`;
      fetch(cartRoute).then(response => response.json()).then(response => {
          this._updateCart(response);
      }).catch((e) => {
          console.error(e);
      }).finally(() => {
          // Cart HTML fetch done
      });
    }

    /**
     * Update cart HTML and Trigger Open Drawer event
     *
     * @param {string} cartHTML String formatted response from fetch cart.js call
     * @param {HTML Node} openDrawerBtn open drawer node
     */
    _updateCart(response, openDrawerBtn = null){
      if(response === null) return;
      
      const focusSelectors = this.runSafely(() => this.focusedControlSelectors()) || [];
      this.setAttribute('updating', true);

      let cartHTML = response[this.dataset.sectionId] || response['template-cart'];
      const parser = new DOMParser();
      cartHTML = parser.parseFromString(cartHTML, 'text/html');

      const cartJSONEle = cartHTML.querySelector('[data-cartScriptJSON]');
      window.globalSpace.cart = JSON.parse(cartJSONEle.textContent);

      Utility.updateSourceFromDestination(`#cart-sales-motivator-${this.dataset.sectionId}`, cartHTML);
      Utility.updateSourceFromDestination(`#cart-form-${this.dataset.sectionId}`, cartHTML);
      Utility.updateSourceFromDestination(`#cart-subtotal-${this.dataset.sectionId}`, cartHTML);
      Utility.updateSourceFromDestination(`#cart-discount-${this.dataset.sectionId}`, cartHTML);
      Utility.updateSourceFromDestination(`#cart-total-${this.dataset.sectionId}`, cartHTML);
      Utility.updateSourceFromDestination(`#cart-discount-codes-${this.dataset.sectionId}`, cartHTML);
      Utility.updateSourceFromDestination(`#cart-item-count-${this.dataset.sectionId}`, cartHTML);

      updateCartCountInHeader();

      // Update cart form container class
      const cartFormContainer = this.querySelector(`#cart-form-container-${this.dataset.sectionId}`);
      (window.globalSpace.cart.item_count <= 0) ? cartFormContainer.classList.add('empty_cart') : cartFormContainer.classList.remove('empty_cart');
      
      this.updateEvents();
      this.runSafely(() => this.restoreFocus(focusSelectors));
      
      if(this.cartDrawer && openDrawerBtn){
        this.initCartDrawer(openDrawerBtn);
      }
      lazyImageObserver.observe();
    }
    
     /**
     * Update Quantity API call 
     *
     * @param {string} line Line Index value of cart Item (Starts from 1)
     * @param {integer} quantity Quantity to update
     * @param {boolean} silent Skip focus and announcement for removals the shopper did not trigger
     */
    updateItemQty(line, quantity, silent = false){
      // const lineItem = document.querySelectorAll('[data-cart-item]')[line-1];
      const lineItem = document.querySelectorAll('[data-cart-item]');
      const changedItem = window.globalSpace.cart.items[line-1];

      if(lineItem.length > 0){ lineItem.forEach(item => item.classList.add('updating')); }
      const body = JSON.stringify({
        line: parseInt(line),
        quantity: parseInt(quantity),
        sections: `${this.dataset.sectionId}`
      });

      fetch(`${routes.cart_change_url}`, { ...Utility.fetchConfig(), ...{ body }})
      .then((response) => response.text())
      .then((_state) => {
        const dataJSON = ((typeof _state == 'object') ? _state : JSON.parse(_state));

        // Handle Error
        if(dataJSON.errors){
          Utility.handleError(dataJSON.errors, 'Cart Update');

          const cartItem = window.globalSpace.cart.items[line-1];
          const qtyInput = this.cartForm.querySelector(`input[data-qty-input][data-index="${line}"]`);
          if(qtyInput) qtyInput.value = cartItem.quantity;
          return;
        }

        eventBus.publish(PUB_SUB_EVENTS.cartUpdate, {
          data: {
            action: (quantity == 0) ? 'remove-item': 'update-qty',
            item: (quantity == 0) ? dataJSON.items_removed : dataJSON.items_added,
            sections: dataJSON.sections
          }
        });
        
        this._updateCart(dataJSON.sections);

        if(!silent){
          this.runSafely(() => {
            if(quantity == 0){
              this.focusCartTitle();
              this.announce(window.cartStrings.item_removed.replace('{{ product }}', this.decodeEntities(changedItem.title)));
            } else {
              const quantityShown = this.cartForm.querySelector(`input[data-qty-input][data-index="${line}"]`).value;
              this.announce(window.cartStrings.quantity_updated.replace('{{ product }}', this.decodeEntities(changedItem.title)).replace('{{ quantity }}', quantityShown));
            }
          });
        }
      }).catch((error) => {
          Utility.handleError(error, 'Cart Update');
      }).finally(() => {
        setTimeout(() => {
          if(lineItem.length > 0){ lineItem.forEach(item => item.classList.remove('updating')); }
        }, 500);
      });
    }
  
    /**
     * Run accessibility follow-up work without risking the cart update: a failure is logged, never shown to the shopper
     *
     * @param {Function} callback Focus or announcement work
     * @returns {*} The callback's result, or undefined when it failed
     */
    runSafely(callback){
      try {
        return callback();
      } catch (error) {
        console.error('Cart accessibility update failed', error);
      }
    }

    /**
     * Selectors that find the focused quantity control again once the cart HTML is replaced.
     * Remove controls are skipped: their removal moves focus to the cart title instead.
     *
     * @returns {string[]} Selector for the control, then its quantity input as a fallback
     */
    focusedControlSelectors(){
      const control = document.activeElement;
      if (!this.cartForm?.contains(control) || control.matches('[data-item-remove], [data-kit-remove]')) return [];

      const { index, kitId, for: direction } = control.dataset;
      const key = index ? `[data-index="${CSS.escape(index)}"]` : kitId ? `[data-kit-id="${CSS.escape(kitId)}"]` : null;
      if (!key) return [];

      const selectors = [`${control.tagName.toLowerCase()}${key}${direction ? `[data-for="${direction}"]` : ''}`];
      // Focusing the input after a tap opens the on-screen keyboard, so only keyboard users get the fallback
      if (control.matches(':focus-visible')) selectors.push(`input${key}`);
      return selectors;
    }

    /**
     * Return focus to the re-rendered control, or to its quantity input when the control is now disabled
     *
     * @param {string[]} selectors Output of focusedControlSelectors
     */
    restoreFocus(selectors){
      const target = selectors.map(selector => this.cartForm.querySelector(selector)).find(element => element && !element.disabled);
      target?.focus();
    }

    /**
     * Announce a cart change to screen readers
     *
     * @param {string} message Text read by the status region
     */
    announce(message){
      this.querySelector('[data-cart-status]').textContent = message;
    }

    /**
     * Shopify escapes the line item title in the cart JSON (Kids&#39; 12), and announce() writes plain text
     *
     * @param {string} text Line item title from the cart JSON
     * @returns {string} The title as plain text
     */
    decodeEntities(text){
      return new DOMParser().parseFromString(text, 'text/html').documentElement.textContent;
    }

    /**
     * Move focus to the cart title once the removed control leaves the DOM.
     * Inside the drawer, the focus trap is rebuilt because its first and last elements may be gone;
     * nothing happens if the drawer was closed before the response arrived.
     * A /cart page first rendered empty has no title.
     * Focus the shopper moved outside the cart form while the request ran is left alone.
     */
    focusCartTitle(){
      const focused = document.activeElement;
      if (focused && focused !== document.body && !this.cartForm?.contains(focused)) return;

      const title = this.querySelector('[data-cart-title]');
      const drawer = this.closest('custom-drawer');

      if (drawer) {
        if (drawer.isOpen) Utility.trapFocus(drawer, title);
        return;
      }
      title?.focus({ preventScroll: true });
    }

    /**
     * Remove Item Event
     */
    removeItem(event){
      event.preventDefault();
      const {currentTarget} = event;
      const itemIndex = currentTarget.dataset.index || null;
      if(itemIndex !== null){
          this.updateItemQty(itemIndex, 0);
      }
    }

    /**
     * Cart Item Qunatity Input change event
     */
    onQtyChange(evt){
      evt.preventDefault();
      const $qtyInput = evt.currentTarget;
      const qtyValue = $qtyInput.value;
      const itemIndex = $qtyInput.dataset.index || null;

      // Same quantity (e.g. "−" at the minimum): skip the request and the "updated" announcement,
      // and show the cart's quantity in case the typed value only parsed to it (e.g. "1abc")
      const cartQuantity = window.globalSpace.cart.items[itemIndex-1]?.quantity;
      if(itemIndex && parseInt(qtyValue) === cartQuantity){
        $qtyInput.value = cartQuantity;
        return;
      }

      if(itemIndex) this.updateItemQty(itemIndex, qtyValue);
    }

    /**
     * Kit Bundle: Remove all items in a kit
     */
    _removeKit(event) {
      event.preventDefault();
      const kitKeys = event.currentTarget.dataset.kitKeys;
      const kitName = event.currentTarget.dataset.kitName;
      if (!kitKeys) return;

      const keys = kitKeys.split(',');
      const updates = {};
      keys.forEach(key => { updates[key] = 0; });

      const lineItems = document.querySelectorAll('[data-cart-item]');
      if (lineItems.length > 0) lineItems.forEach(item => item.classList.add('updating'));

      const body = JSON.stringify({
        updates: updates,
        sections: this.dataset.sectionId
      });

      fetch(routes.cart_update_url + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: body
      })
      .then(response => response.json())
      .then(data => {
        if (data.errors) {
          Utility.handleError(data.errors, 'Cart Update');
          return;
        }
        eventBus.publish(PUB_SUB_EVENTS.cartUpdate, {
          data: { action: 'remove-item', item: null, sections: data.sections }
        });
        this._updateCart(data.sections);
        this.runSafely(() => {
          this.focusCartTitle();
          this.announce(window.cartStrings.item_removed.replace('{{ product }}', kitName));
        });
      })
      .catch(error => Utility.handleError(error, 'Cart Update'))
      .finally(() => {
        setTimeout(() => {
          if (lineItems.length > 0) lineItems.forEach(item => item.classList.remove('updating'));
        }, 500);
      });
    }

    /**
     * Kit Bundle: Handle +/- buttons for kit quantity
     */
    _onKitQtyBtn(event) {
      event.preventDefault();
      const btn = event.currentTarget;
      const direction = btn.dataset.for;
      const kitId = btn.dataset.kitId;
      const qtyInput = this.cartForm.querySelector(`input[data-kit-qty-input][data-kit-id="${kitId}"]`);
      if (!qtyInput) return;

      let qty = parseInt(qtyInput.value, 10) || 1;
      if (direction === 'increase') {
        qty += 1;
      } else if (direction === 'decrease') {
        qty = Math.max(0, qty - 1);
      }
      qtyInput.value = qty;
      qtyInput.dispatchEvent(new Event('change'));
    }

    /**
     * Kit Bundle: Update all items in a kit to the same quantity
     */
    _updateKitQty(event) {
      event.preventDefault();
      const input = event.currentTarget;
      const kitKeys = input.dataset.kitKeys;
      const prevQty = input.dataset.prevQty || input.defaultValue || input.value;
      const newQty = parseInt(input.value, 10);
      if (!kitKeys || isNaN(newQty)) return;

      input.dataset.prevQty = prevQty;

      const keys = kitKeys.split(',');
      const updates = {};
      keys.forEach(key => { updates[key] = newQty; });

      const lineItems = document.querySelectorAll('[data-cart-item]');
      if (lineItems.length > 0) lineItems.forEach(item => item.classList.add('updating'));

      const rollbackQty = () => {
        input.value = prevQty;
      };

      const body = JSON.stringify({
        updates: updates,
        sections: this.dataset.sectionId
      });

      fetch(routes.cart_update_url + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: body
      })
      .then(response => response.json())
      .then(data => {
        if (data.errors) {
          rollbackQty();
          Utility.handleError(data.errors, 'Cart Update');
          return;
        }
        eventBus.publish(PUB_SUB_EVENTS.cartUpdate, {
          data: {
            action: (newQty === 0) ? 'remove-item' : 'update-qty',
            item: null,
            sections: data.sections
          }
        });
        this._updateCart(data.sections);

        this.runSafely(() => {
          if (newQty === 0) {
            this.focusCartTitle();
            this.announce(window.cartStrings.item_removed.replace('{{ product }}', input.dataset.kitName));
          } else {
            const quantityShown = this.cartForm.querySelector(`input[data-kit-qty-input][data-kit-id="${CSS.escape(input.dataset.kitId)}"]`).value;
            this.announce(window.cartStrings.quantity_updated.replace('{{ product }}', input.dataset.kitName).replace('{{ quantity }}', quantityShown));
          }
        });
      })
      .catch(error => {
        rollbackQty();
        Utility.handleError(error, 'Cart Update');
      })
      .finally(() => {
        setTimeout(() => {
          if (lineItems.length > 0) lineItems.forEach(item => item.classList.remove('updating'));
        }, 500);
      });
    }

    disconnectedCallback() {
      // Remove keydown listener
      if (this.cartForm && this._handleKeydown) {
        this.cartForm.removeEventListener('keydown', this._handleKeydown);
        this._handleKeydown = null;
      }

      // Unsubscribe from event bus
      if (this.unsubscribeCartUpdate) {
        this.unsubscribeCartUpdate();
        this.unsubscribeCartUpdate = null;
      }

      // Clean up references
      this.cartForm = null;
      this.cartDrawer = null;
      this._handleCartUpdate = null;
    }
}
customElements.define("cart-form", AjaxCart);